/** @type {HTMLTemplateElement} */
const baseTemplate = document.querySelector('#c3accessibility-template');

/** @type {HTMLDivElement} */
const template = baseTemplate.cloneNode(true).content.firstElementChild;

const buttons = {
    /** @type {HTMLButtonElement} */
    save: template.querySelector('.c3accessibility-button[data-action="save"]'),
    /** @type {HTMLButtonElement} */
    cancel: template.querySelector('.c3accessibility-button[data-action="cancel"]'),
};

const elements = {
    /** @type {HTMLDialogElement} */
    dialog: template.querySelector('#c3accessibility-dialog'),
    /** @type {HTMLButtonElement} */
    flag: template.querySelector('#c3accessibility-flag'),
    /** @type {HTMLFormElement} */
    form: template.querySelector('#c3accessibility-settings-form'),
};

const availableOptions = new Set(template.dataset.options.split(','));

elements.flag.addEventListener('click', () => {
    viewTransition(() => {
        elements.dialog.showModal();
    });
});

elements.form.addEventListener('submit', e => {
    e.preventDefault();
    const data = new FormData(elements.form);
    const storedData = {};
    for (const [key, value] of data) {
        if (!availableOptions.has(key)) {
            continue;
        }
        storedData[key] = value;
    }

    viewTransition(() => {
        window.c3accessibility.commitSettings(storedData);
        elements.dialog.close();
        window.dispatchEvent(new CustomEvent('c3accessibility:update', {
            detail: {
                data: storedData
            }
        }));
    });
});

buttons.cancel.addEventListener('click', () => {
    viewTransition(() => {
        elements.dialog.close();
    });
    initDialogForm();
});

/** @type {Record<string, 'radio' | 'select' | 'checkbox'>} */
const fields = {
    fontSize: 'radio',
    lineHeight: 'radio',
    fontFamily: 'select',
    colorFilter: 'select',
    graphics: 'select',
    reduceMotion: 'checkbox'
};

/** @type {Record<string, string>} */
const initialValues = window.c3accessibility.getSettings();

if (!localStorage.getItem('c3accessibility.initialized')) {
    if (window.matchMedia('(prefers-contrast: more)').matches) {
        initialValues.colorFilter = 'high-contrast';
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        initialValues.reduceMotion = 'true';
    }
    window.c3accessibility.commitSettings(initialValues);
    localStorage.setItem('c3accessibility.initialized', 'true');
}

initDialogForm();

document.body.append(template);

customElements.define('c3accessibility-icon', class extends HTMLElement {
    constructor() {
        super();
        this.icon = this.getAttribute('icon');
        this.src = window.c3accessibility.assets.icons[this.icon]; //`/typo3conf/ext/c3accessibility/Resources/Public/Assets/Icons/${this.icon}.svg`;
        this.content = fetch(this.src)
            .then(res => {
                if (!res.ok || res.status >= 400) {
                    return Promise.resolve(null);
                }
                return res.text();
            })
            .catch(() => null);
        this.setAttribute('aria-hidden', 'true');
    }

    connectedCallback() {
        this.content.then(res => {
            this.innerHTML = res;
        });
    }
});

function initDialogForm() {
    for (const [key, value] of Object.entries(window.c3accessibility.getSettings())) {
        const type = fields[key];

        switch (type) {
            case 'radio': {
                /** @type {HTMLInputElement} */
                const element = elements.form.querySelector(`[name="${key}"][value="${value}"]`);
                if (element) {
                    element.checked = true;
                }
                break;
            }
            case 'select': {
                /** @type {HTMLSelectElement} */
                const element = elements.form.querySelector(`[name="${key}"]`);
                if (element) {
                    element.value = value;
                }
                break;
            }
            case 'checkbox': {
                /** @type {HTMLInputElement} */
                const element = elements.form.querySelector(`[name="${key}"]`);
                if (element) {
                    element.checked = value === 'true';
                }
                break;
            }
        }
    }
}

/**
 * polyfill function for view transitions. Does not show transition, if the browser does not support it
 * @param {() => void} callback
 */
export function viewTransition(callback) {
    if (!document.startViewTransition) {
        callback();
        return {
            finished: Promise.resolve()
        };
    }

    return document.startViewTransition(() => {
        callback();
    });
}